import { QueryObserverOptions } from "@tanstack/react-query"

import { CommunicationTemplateRequest } from "@shared/dtos/requests/practiceRequests.dto"
import { CommunicationTemplateConfigResponse } from "@shared/dtos/responses/practiceResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

// Templates rarely change while the user is editing them, and refetching on
// window focus wipes unsaved form state — so opt out for every caller.
export const getAllQueryOptions: Partial<QueryObserverOptions> = {
  refetchOnWindowFocus: false,
}

export const getAll = async (practiceId: string): Promise<CommunicationTemplateConfigResponse> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/communicationtemplates`,
    method: "get",
  })
  return resp.data
}

export const edit = async (practiceId: string, req: CommunicationTemplateRequest): Promise<void> => {
  await axiosAuth({
    url: `/practices/${practiceId}/communicationtemplates`,
    method: "put",
    data: req,
  })
  return undefined
}
